import { CartAchRequest, CartCardRequest, StoreId, StoreResponse } from '@business/entities/store';
import { Endpoint } from '../endpoint';

export function fetchStore(id: StoreId) {
  return Endpoint.get<StoreResponse>(`@gc/cart/store/${id}`);
}

export function payWithACH(data: CartAchRequest) {
  return Endpoint.post<void>(`@gc/cart/ach`, { data });
}
export function payWithCard(data: CartCardRequest) {
  return Endpoint.post<void>(`@gc/cart/card`, { data });
}

export function payInvoiceWithACH(data: Partial<CartAchRequest>) {
  return Endpoint.post<void>(`@gc/cart/invoice-ach`, { data });
}
export function payInvoiceWithCard(data: Partial<CartCardRequest>) {
  return Endpoint.post<void>(`@gc/cart/invoice-card`, { data });
}
